import { useEffect } from 'react'
import { useLocation } from 'wouter'

let isRedirecting = false

export const RedirectToSignIn: React.FC = () => {
  const [, navigate] = useLocation()

  useEffect(() => {
    if (isRedirecting) return

    isRedirecting = true

    navigate(`/sign-in?return_to=${location.pathname}`)
  }, [navigate])

  return null
}
